// Check the checkbox in the stepsform
// if the checkbox name matches url hash

export default () => {

  // do we have a hash?
  if (!location.hash) return

  // do we have a form?
  const stepsform = document.querySelector('.js-steps-form')
  if (! stepsform ) return

  // do we have any checkboxes?
  let checkboxes = document.querySelectorAll('.c-checkbox__element')
  if (! checkboxes) return

  // loop through the checkboxes to check for a match
  // between url hash and checkbox name
  ;[...checkboxes].forEach(checkbox => {

    // make checked if we have a match
    if ( checkbox.name == location.hash.substr(1) ) {
      checkbox.checked = true
    }
  })

}



// WEBPACK FOOTER //
// ./src/js/modules/CheckFlyerCheckbox.js